// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/mask_logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer utilities {
  .mask-image {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mask-repeat: no-repeat;
    mask-size: cover;
    -webkit-mask-position-y: bottom;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/index.css"],"names":[],"mappings":"AAAA;EACE;IACE,mDAAoD;IACpD,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;EACjC;AACF","sourcesContent":["@layer utilities {\n  .mask-image {\n    mask-image: url('../../assets/images/mask_logo.png');\n    mask-repeat: no-repeat;\n    mask-size: cover;\n    -webkit-mask-position-y: bottom;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
